import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormEnemaIcon.tsx
const MedFormEnemaIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "enema-icon.svg",
		alt: t("medicationForm.enema")
	});
};

//#endregion
export { MedFormEnemaIcon };